var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "app" } },
    [
      _c(
        "b-card",
        [
          _c(
            "b-card-header",
            [
              _c("b-card-title", [
                _vm._v("Unconverted Leads and Opportunity Cost"),
              ]),
            ],
            1
          ),
          _c("b-table", {
            staticClass: "mb-4",
            attrs: {
              items: _vm.data,
              fields: _vm.fields,
              striped: "",
              hover: "",
              responsive: "",
            },
            scopedSlots: _vm._u([
              {
                key: "cell(totalEstimateValue)",
                fn: function (data) {
                  return [
                    _vm._v(" $" + _vm._s(_vm.formatCurrency(data.value)) + " "),
                  ]
                },
              },
            ]),
          }),
          _c("apexchart", {
            attrs: {
              type: "bar",
              height: 350,
              options: _vm.chartOptions,
              series: _vm.series,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }